var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		$(document).ready(function() {
			site.frontpage.mobileTap();
		});
	},

	mobileTap: function() {
		var $wondersItem = $('.forsida-wonders .item');
		$wondersItem.bind('click', function(e) {
			if (!$(this).hasClass('mobile-hover')) {
				e.preventDefault();
			}
			$wondersItem.not(this).removeClass('mobile-hover');
			$(this).toggleClass('mobile-hover');
		});
	}
};

site.extras = site.extras || {};
site.extras = $.extend(site.extras, {
	mapResize: function() {
		$('a.mapResize').on('click', function(e) {
			e.preventDefault();
			var $this = $(this),
				currCenter = moya.map.gMap.getCenter();

			$this.toggleClass('resized');

			if ($this.hasClass('resized')) {
				$('.image', '.media').hide();
				$('.map', '.media').css('width', '100%');
				google.maps.event.trigger(moya.map.gMap, 'resize');
				moya.map.gMap.setCenter(currCenter);
				$('i', $this).removeClass('fa-search-plus').addClass('fa-search-minus');
			}
			else {
				$('.image', '.media').show();
				$('.map', '.media').removeAttr('style');
				google.maps.event.trigger(moya.map.gMap, 'resize');
				moya.map.gMap.setCenter(currCenter);
				$('i', $this).removeClass('fa-search-minus').addClass('fa-search-plus');
			}
		});
	},

	toggleSeason: function() {
		$('.item__expand').on('click', function(e) {
			e.preventDefault();
			var $this = $(this);
			$this.toggleClass('down');

			$this.next().toggle();
			
			console.log('wat');

			$('#extras').find('.items').isotope('reloadItems').isotope();
		})
	}
});

// Put back button on bottom of company info on mobile/tablet devices.
site.entryFooter = {
	init:function() {
		if ($(".seedo__item__companyinfo")) {
			if ( $(window).width() < 992) {
				$(".entryFooter").appendTo(".seedo__item__companyinfo");
			} else {
				$(".entryFooter").appendTo(".seedo__item__description")
			}
		}
	}
};

site.calendarFilter = {
	init: function() {
		layout = typeof layout !== 'undefined' ? layout : 'fitRows';

		$('.filter-buttons').change(function () {
			var val = $(this).find("option:selected").val();
			var scrollTop = $(window).scrollTop();
			location.hash = val;
			window.scrollTo(0, scrollTop);
		});
		$(window).load(function () {
			var $container = $('#calendar .eventList');
			$container.isotope({
				// options
				itemSelector: '.event',
				layoutMode: layout,
				hiddenStyle: {
					opacity: 0
				},
				visibleStyle: {
					opacity: 1
				}
			});
			$container.addClass('loaded');
		});
		$(function () {
			$(window).bind("hashchange", function (e) {
				$('.filter-buttons a').removeClass('selected');
				var b = location.hash;
				b = (b == '') ? '#all' : b;

				if (b) {
					b = b.substr(1, b.length);
					var filterValue = (b == 'all') ? '*' : '.' + b;
					var $container = $('#calendar .eventList');
					console.log(filterValue);
					$container.isotope({filter: filterValue});
					$(".filter-buttons ." + b).attr('selected', 'selected');
					$(".filter-buttons ." + b).addClass('selected');
				}
			});
			$(window).trigger("hashchange");
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	site.accessibility.init();
	site.entryFooter.init();

	var $body = $('body');

	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	$( window ).resize(function() {
		site.entryFooter.init();
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
